import Vue from 'vue';

export const state = () => ({
  redirect_url: null
})

export const mutations = {
  setState(state, {key, value}) {
    state[key] = value;
  }
}

export const actions = {
  
}
